import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const PullCLookupMetadata = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  getStudyCDISCCLookUp,
}) => {
  const { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pullLibraryData, setPullLibraryData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const getCDISCCLookUp = async () => {
    try {
      setLoading(true);
      const data = await cdiscManagementService.getCDISCCLookUp(
        "active"
      );
      const rows = data?.data || [];
      setPullLibraryData(rows);
      setSelectedRows([]);
      setSelectAll(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (studyId) {
      getCDISCCLookUp();
    }
  }, [studyId]);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      const allIds = pullLibraryData.map((item) => item.lookUpId);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(id);
      const updated = isSelected ? prev.filter((x) => x !== id) : [...prev, id];
      setSelectAll(updated.length === pullLibraryData.length);
      return updated;
    });
  };

  const pullStudyCDISCCLookUpData = async () => {
    setButtonLoader(true);
    const userData = {
      lookUpIds: selectedRows,
      studyId,
    };
    const data = await cdiscManagementService.pullStudyCDISCCLookUpData(userData);
    if (data?.statusCode === 200) {
      Hide();
      getStudyCDISCCLookUp();
      getCDISCCLookUp();
      setSelectedRows([]);
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} style={{ width: 775 }} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {loading ? (
          <PageLoader />
        ) : pullLibraryData.length === 0 ? (
          <NoDataFoundTable MSG="CLookups data not found!." />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 bg-white">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    <Form.Check
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Mapping Group</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Domain</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Test CD</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Source Unit</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Target Unit</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>Factor</th>
                  <th onMouseDown={(e) => onMouseDown(e, 7)}>Afine Scale</th>
                  <th onMouseDown={(e) => onMouseDown(e, 8)}>Afine Shift</th>
                  <th onMouseDown={(e) => onMouseDown(e, 9)}>Formula</th>
                </tr>
              </thead>
              <tbody>
                {pullLibraryData.map((item) => {
                  const rowId = item.lookUpId;
                  return (
                    <tr key={rowId}>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={selectedRows.includes(rowId)}
                          onChange={() => handleRowSelect(rowId)}
                        />
                      </td>
                      <td>{item.mappingGroup}</td>
                      <td>{item.domain}</td>
                      <td>{item.testCD}</td>
                      <td>{item.sourceUnit}</td>
                      <td>{item.targetUnit}</td>
                      <td>{item.factor}</td>
                      <td>{item.afineScale}</td>
                      <td>{item.afineShift}</td>
                      <td>{item.formula}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Offcanvas.Body>

      <div className="p-2 border-top text-end">
        <button
          className="updateProfile"
          disabled={buttonLoader || selectedRows.length === 0}
          onClick={pullStudyCDISCCLookUpData}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Pulling...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default PullCLookupMetadata;
